module.exports = __webpack_public_path__ + "img/step40.f4b7f90e.png";